export const parseContentDispositionFilename = (header: string | null): string | undefined => {
  if (!header) {
    return undefined
  }

  const utf8Match = header.match(/filename\*=UTF-8''(.+?)(?:;|$)/i)

  if (utf8Match) {
    return decodeURIComponent(utf8Match[1])
  }

  const quotedMatch = header.match(/filename="([^"]+)"/i)

  if (quotedMatch) {
    return quotedMatch[1]
  }

  const unquotedMatch = header.match(/filename=([^;\s]+)/i)

  if (unquotedMatch) {
    return unquotedMatch[1]
  }

  return undefined
}
